import { render, staticRenderFns } from "./EvaluateDoctorList.vue?vue&type=template&id=5c6ae575&scoped=true&"
import script from "./EvaluateDoctorList.vue?vue&type=script&lang=js&"
export * from "./EvaluateDoctorList.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateDoctorList.vue?vue&type=style&index=0&id=5c6ae575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ae575",
  null
  
)

export default component.exports